module.exports = __webpack_public_path__ + "media/images/application/template/arrow-right-c3b9f5c3628641d578298ce64d0e0791.svg";